export default {
    current_choice: 'Trenutni izbor',
    book_now: 'Rezerviši sada',
    minimum_age: 'Samo za starije od {age} godina',
    excess_liability: 'Prekomerna odgovornost',
    security_deposit: 'Sigurnosni depozit',
    fuel_policy: 'Politika goriva',
    like_for_like: 'Isto za isto',
    full_to_full: 'Puno do punog',
    miles_per_rental: '{mileage} besplatnih milja po najmu',
    km_per_rental: '{mileage} besplatnih km po najmu',
    unlimited_mileage: 'Neograničena kilometraža',
    unlimited_mileage_km: 'Neograničeni km',
    non_amendable: 'Nije moguće izmeniti',
    non_refundable: 'Nije moguće refundirati',
    free_cancellation_until: 'Besplatno otkazivanje do',
    basic_free_cancellation: 'Besplatno otkazivanje do 48 sati pre početka najma',
    cancellation_in_line_with: 'Otkazivanje u skladu sa',
    tcs: 'Uslovi i odredbe',
    free_extras_on_collection: 'Dva besplatna dodatka pri preuzimanju',
    glass_and_tyres_covered: 'Stakla i gume su pokriveni',
    number_of_passengers: 'Broj putnika',
    number_of_bags: 'Broj torbi',
    fuel_type: 'Tip goriva',
    co2: 'CO2',
    aircon: 'Klima uređaj',
    transmission: 'Menjač',
    book_type: 'Rezerviši {type}',
    debit_card_deposit: 'Prihvaćene debitne kartice za depozit',
    fast_track_included: 'Brza usluga uključena',
    view_all: 'Pogledaj sve',
};
